import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { SERVICES } from "@/data/services";
import { Reveal, Eyebrow } from "./Motion";

const SPANS = [
  "md:col-span-2 lg:col-span-4 lg:row-span-2",
  "lg:col-span-2",
  "lg:col-span-2",
  "lg:col-span-3",
  "lg:col-span-3",
];

const Card = ({ s, i }) => {
  const Icon = s.icon;
  const feature = i === 0;
  return (
    <motion.div
      initial={{ opacity: 0, y: 32 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.15 }}
      transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1], delay: i * 0.08 }}
      className={SPANS[i]}
    >
      <Link
        to={`/services/${s.slug}`}
        data-testid={`bento-card-${s.slug}`}
        className="group relative flex h-full min-h-[280px] flex-col justify-between overflow-hidden border border-[#E2ECEB] bg-white p-8 transition-[border-color,box-shadow] duration-500 hover:border-[#D4AF37] hover:shadow-[0_30px_60px_-30px_rgba(7,78,72,0.35)] lg:p-10"
      >
        {feature && (
          <div className="clip-corner absolute inset-0">
            <img src={s.image} alt={s.title} className="h-full w-full object-cover transition-transform duration-[1.4s] ease-out group-hover:scale-105" />
            <div className="absolute inset-0 bg-gradient-to-t from-[#063A36] via-[#063A36]/60 to-[#063A36]/10" />
          </div>
        )}
        <div className="relative flex items-start justify-between">
          <span className={`font-display flex items-center gap-3 text-sm font-bold tracking-[0.3em] ${feature ? "text-[#F7EFD2]" : "text-[#0D9488]"}`} data-testid={`bento-verb-${s.slug}`}>
            <span className="h-2 w-2 rotate-45 bg-[#D4AF37]" />
            {s.verb}
          </span>
          <span className={`flex h-12 w-12 items-center justify-center border transition-colors duration-500 ${feature ? "border-white/30 text-[#D4AF37]" : "border-[#E2ECEB] text-[#D4AF37] group-hover:border-[#D4AF37]"}`}>
            <Icon size={20} strokeWidth={1.5} />
          </span>
        </div>
        <div className={`relative ${feature ? "mt-40 lg:mt-0" : "mt-10"}`}>
          <h3 className={`font-display font-bold tracking-tight ${feature ? "text-3xl text-white lg:text-5xl" : "text-2xl text-[#0D9488]"}`}>{s.title}</h3>
          <p className={`mt-4 max-w-md text-sm leading-relaxed md:text-base ${feature ? "text-[#E3F1EF]" : "text-[#2D6A64]"}`}>{s.tagline}</p>
          <span className={`font-display mt-8 inline-flex items-center gap-3 border px-5 py-3 text-sm font-semibold transition-colors duration-300 group-hover:border-[#D4AF37] ${feature ? "border-white/50 text-white" : "border-[#0D9488]/40 text-[#0D9488]"}`} data-testid={`bento-explore-${s.slug}`}>
            Explore {s.verb}
            <span className="transition-transform duration-300 group-hover:translate-x-1.5" aria-hidden>→</span>
          </span>
        </div>
      </Link>
    </motion.div>
  );
};

export const ServicesBento = () => (
  <section className="mx-auto max-w-[1400px] px-6 py-24 lg:px-12 lg:py-36" data-testid="services-bento">
    <div className="mb-16 grid gap-8 lg:grid-cols-12">
      <Reveal className="lg:col-span-6">
        <Eyebrow>Our Solutions</Eyebrow>
        <h2 className="font-display mt-6 text-3xl font-bold tracking-tight text-[#0D9488] sm:text-4xl lg:text-5xl">
          HR, built around your needs.
        </h2>
      </Reveal>
      <Reveal delay={0.1} className="lg:col-span-5 lg:col-start-8 lg:self-end">
        <p className="text-base leading-relaxed text-[#2D6A64] md:text-lg">
          Whether you need to build your workforce, run it seamlessly, find the right talent, grow your people or transform your HR function, KRIMZON brings the right expertise, under one roof.
        </p>
      </Reveal>
    </div>
    <div className="grid auto-rows-[minmax(280px,auto)] gap-5 md:grid-cols-2 lg:grid-cols-6">
      {SERVICES.map((s, i) => (
        <Card key={s.slug} s={s} i={i} />
      ))}
    </div>
  </section>
);
